import script from "./MainDarkLandingBarTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainDarkLandingBarTop.vue?vue&type=script&lang=ts&setup=true"

import "./MainDarkLandingBarTop.vue?vue&type=style&index=0&id=3498d320&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3498d320"]])

export default __exports__